import { FieldConfig } from "~/components/Forms/DealerPassportForm2/types";

export const getDealerRequisites = (
  t: (key: string) => string,
  prefix: string
): FieldConfig[] => [
  {
    name: `${prefix}legalAddress`,
    label: t(`dealers.legalAddress`), // Юридический адрес
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}postalAddress`,
    label: t(`dealers.postalAddress`), // Почтовый адрес
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}legalDealerName`,
    label: t(`dealers.legalDealerName`), // Юридическое название
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}tradeDealerName`,
    label: t(`dealers.tradeDealerName`), // Торговое название
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}kpp`,
    label: t(`dealers.kpp`), // КПП
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}ogrn`,
    label: t(`dealers.ogrn`), // ОГРН
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}inn`,
    label: t(`dealers.inn`), // ИНН
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}code`,
    label: t(`dealers.code`), // Код филиала
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}birCode`,
    label: t(`dealers.birCode`), // Код БИР
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}egrNumber`,
    label: t(`dealers.EGR_Number`), // Номер ЕГР
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}egrSeries`,
    label: t(`dealers.EGR_Series`), // Серия ЕГР
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}egrDate`,
    label: t(`dealers.EGR_Date`), // Дата ЕГР
    type: "text",
    disabled: true,
  },
];

export const getDealerBankDetails = (
  t: (key: string) => string,
  prefix: string
): FieldConfig[] => [
  {
    name: `${prefix}bankName`,
    label: t(`dealers.bankName`), // Название банка
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}bik`,
    label: t(`dealers.BIK`), // БИК
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}correspondentAccount`,
    label: t(`dealers.correspondentAccount`), // Корреспондентский счёт
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}settlementAccount`,
    label: t(`dealers.settlementAccount`), // Расчётный счёт
    type: "text",
    disabled: true,
  },
  {
    name: `${prefix}regionCode`,
    label: t(`dealers.regionCode`), // Код региона
    type: "text",
    disabled: true,
  },
];
